import type { ReactNode } from 'react';
import { CollapsibleSection } from '../../CollapsibleSection';
import { LoadingSection } from '../../layout/LoadingSection';

interface PayloadSectionProps {
  title: string;
  isExpanded: boolean;
  isLoading: boolean;
  onToggle: () => void;
  onCopy: () => void;
  children: ReactNode;
}

export function PayloadSection({
  title,
  isExpanded,
  isLoading,
  onToggle,
  onCopy,
  children,
}: PayloadSectionProps) {
  return (
    <LoadingSection isLoading={isLoading}>
      <CollapsibleSection
        title={title}
        isExpanded={isExpanded}
        onToggle={onToggle}
        onCopy={onCopy}
      >
        {children}
      </CollapsibleSection>
    </LoadingSection>
  );
}
